/**
 * Converts an array ownerships with an owner key into an array of owners with
 * an ownerships key.
 *
 * Since this component renders a list of owners, rather than ownerships, using
 * this method simplifies a lot of the rendering logic.
 *
 * @example
 * normalizeOwnershipsAsOwners([{
 *   id: 1, ownable_type: 'Lesson', owner: { id: 1 name: 'User A' },
 *   id: 2, ownable_type: 'Path', owner: { id: 1 name: 'User A' },
 *   id: 3, ownable_type: 'Path', owner: { id: 2 name: 'User B' },
 * ])
 *
 * // returns
 *
 * [{
 *   id: 1,
 *   name: 'User A',
 *   directOwnership: {
 *     // A reference to the direct ownership object of the lesson
 *     // E.g. this will be one of the two objects in the ownerships below
 *   },
 *   ownerships: [
 *     { id: 1, ownable_type: 'Lesson', ...etc },
 *     { id: 2, ownable_type: 'Path', ...etc },
 *   ],
 * }, {
 *   id: 2,
 *   name: 'User B',
 *   ownerships: [
 *     { id: 3, ownable_type: 'path', ...etc },
 *   ],
 * }]
 */
export function normalizeOwnershipsAsOwners(ownerships, idKey = 'id') {
  const ownershipsByOwners = ownerships.reduce((owners, ownership) => {
    const { owner } = ownership;
    // creating an owner object if it doesn't exist yet
    if (!owners[owner[idKey]]) {
      owners[owner[idKey]] = { ...owner, ownerships: [] };
    }
    // adding the ownership to the owner object
    owners[owner[idKey]].ownerships.push(ownership);
    // assigning a reference to the direct ownership (on the lesson) since an
    // ownership can be inherited from a path
    if (ownership.direct_ownership) {
      owners[owner[idKey]].directOwnership = ownership;
    }
    return owners;
  }, {});
  return Object.values(ownershipsByOwners);
}
